import { useState } from "react";
import "./Avatar.css";

function getInitials(name) {
  if (!name || typeof name !== "string") return "?";
  const parts = name
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (parts.length === 0) return "?";
  if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
  return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
}

export default function Avatar({
  name = "",
  imageUrl,
  size = 40,
  alt,
  className,
  ...rest
}) {
  const [errored, setErrored] = useState(false);
  const showImage = imageUrl && !errored;
  const initials = getInitials(name);
  const style = {
    width: size,
    height: size,
    fontSize: Math.max(11, Math.round(size * 0.4)),
  };
  const cls = [
    "vs-avatar",
    !showImage && "vs-avatar--initials",
    className,
  ]
    .filter(Boolean)
    .join(" ");
  return (
    <span className={cls} style={style} {...rest}>
      {showImage ? (
        <img
          src={imageUrl}
          alt={alt || name || ""}
          className="vs-avatar__img"
          onError={() => setErrored(true)}
        />
      ) : (
        <span className="vs-avatar__initials" aria-label={name || undefined}>
          {initials}
        </span>
      )}
    </span>
  );
}
